// extracted by mini-css-extract-plugin
export var container = "WpImage-module--container--9fd07";
export var image = "WpImage-module--image--e3acb";